import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { IResultModel, ResultModel } from 'src/app/models/general/result.model';
import { State } from 'src/app/models/state.model';
import { SupportedLanguage } from 'src/app/models/supported-language.model';
import { UserProfile } from 'src/app/models/user-profile.model';
import { StateService } from 'src/app/services';
import { AuthService } from 'src/app/services/auth.service';
import { LanguageService } from 'src/app/services/language.service';
import { CardComponent } from 'src/app/shared/components';
import { ErrorMessageService } from 'src/app/shared/services';
import { EmployeeState } from 'src/app/store/employee.state';

@UntilDestroy()
@Component({
  selector: 'app-user-language',
  templateUrl: './user-language.component.html',
  styleUrls: ['./user-language.component.scss']
})
export class UserLanguageComponent implements OnInit {

  public model$: Observable<UserProfile>;
  public languageForm: UntypedFormGroup;
  public state: State;
  
  public supportedLanguages: SupportedLanguage[];

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    stateService: StateService,
    private msgService: ErrorMessageService,
    private languageService: LanguageService,
    private employeeStore: EmployeeState
  ) {
      this.state = stateService.state;
      this.model$ = this.employeeStore.employee.obs$;
  }

  @ViewChild('card')
  card: CardComponent;

  ngOnInit(): void {
    this.supportedLanguages = this.languageService.getSupportedLanguages();
    this.languageForm = this.createForm();

    this.model$
        .pipe(untilDestroyed(this))
        .subscribe(data => {
            if (data) {
                 this.languageForm.patchValue({ language: data.languageCode });
            }
        });
  }

  createForm(): UntypedFormGroup {
    return this.fb.group({
      'language': ['', [Validators.required]]
    });
  }

  getLanguageName(code: string): string {
    const lang = this.supportedLanguages.find(lang => lang.code === code);
    return lang ? lang.name : '';
  }

  save() {
    const formData = this.languageForm.value;
    const newLang = formData.language as string;

    const data = {
      userId: this.employeeStore.employee.value.id,
      languageCode: newLang
    };

    this.authService.changeUserLanguage(data).subscribe({ next: async () => {
      this.card.actionState.editMode = false;
      
      // Update store
      const currentUser = this.employeeStore.employee.value;
      if (currentUser) {
          this.employeeStore.employee.value = { ...currentUser, languageCode: newLang };
      }

      // If logged in user is the same as edited user
      if (this.state.me.value.id === this.employeeStore.employee.value.id) {
          await this.languageService.setLanguage(newLang);
          // Update me state as well
          this.state.me.value = { ...this.state.me.value, languageCode: newLang };
      }
      
      this.msgService.showSnackBarMessage('saveSuccessful');
    }, error: (err: IResultModel<ResultModel>) => {
      this.msgService.handleError<ResultModel>(err);
    } });
  }
}
